<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-5">
  @if (serverError) {
    <div class="rounded-lg border border-error-200 bg-error-50 px-3 py-2 text-sm text-error-700 dark:border-error-800 dark:bg-error-500/10 dark:text-error-400">
      {{ serverError }}
    </div>
  }

  <div class="grid gap-5 sm:grid-cols-2">
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Nom affiché *</label>
      <input
        type="text"
        formControlName="name"
        placeholder="Wave Sénégal"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
      @if (showError('name')) {
        <p class="mt-1 text-xs text-error-600 dark:text-error-400">Nom requis (max 80 caractères).</p>
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Code service *</label>
      <input
        type="text"
        formControlName="serviceCode"
        placeholder="WAVE_SN_API_CASH_IN"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 font-mono text-xs text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
      @if (showError('serviceCode')) {
        <p class="mt-1 text-xs text-error-600 dark:text-error-400">Code service requis (unique côté backend, transmis à GUTouch).</p>
      } @else {
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Identifiant unique transmis au PSP (GUTouch).</p>
      }
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Type *</label>
      <app-pretty-select
        formControlName="type"
        [options]="typeOptions"
        placeholder="Choisir un type"
      />
    </div>

    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">URL du logo</label>
      <input
        type="url"
        formControlName="imageUrl"
        placeholder="https://…/wave-logo.png"
        class="h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Optionnel — affiché dans les apps client/owner.</p>
    </div>
  </div>

  <div class="flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-5 dark:border-gray-800">
    <button
      type="button"
      (click)="onCancel()"
      [disabled]="submitting"
      class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5"
    >
      Annuler
    </button>
    <button
      type="submit"
      [disabled]="submitting || form.invalid"
      class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50"
    >
      @if (submitting) {
        @if (mode === 'create') { Création… } @else { Enregistrement… }
      } @else {
        @if (mode === 'create') { Créer } @else { Enregistrer }
      }
    </button>
  </div>
</form>
